<h5>בחר יחידה</h5>
<input type="text" [(ngModel)]="searchTerm" [placeholder]=" 'חפש לפי שם יחידה' " class="project-search" (focus)="showResultsF()">
<div *ngIf="showResoults && parentShowResoults" class="results-holder">
    <ul>
        <li *ngFor="let unit of units | unitsFilter:searchTerm">
            <a *ngIf="unit.status !== 'sold'" href="javascript:;" (click)="sendNumber(unit.number)"> <span >{{ unit.buildTitle }}</span>  - {{ unit.number }} </a>
        </li>
    </ul>

</div>



<!-- <h5>showSearchResults</h5>
<div *ngFor="let unit from showSearchResults | projFilter:searchTerm">
    {{ showSearchResults }}
</div> -->
